export default "__VITE_ASSET__BoF1DF_X__"